import React, { useEffect, useRef } from 'react';

function Iluminacion({ onBackgroundImageCheck }) {
    const sectionRef = useRef(null);

    useEffect(() => {
        const sectionElement = sectionRef.current;
        const style = window.getComputedStyle(sectionElement);
        const hasBackgroundImage = style.backgroundImage !== 'none';
        onBackgroundImageCheck(hasBackgroundImage);
    }, [onBackgroundImageCheck]);

    return (
        <>
            <div id="carouseliluminacion" className="carousel slide w-100 carousel-fade" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {/* Primera imagen */}
                    <div className="carousel-item active">
                        <div className="d-flex w-100 d-block col-12 col-md-5 position-relative" id="imgiluminacion" ref={sectionRef}>
                            <div className="position-absolute w-100 h-100"></div>

                            <div className="row align-self-center w-100 d-none d-md-flex text-start" id="alineardescripcion">
                                <div className="col-12 col-md-7 mt-3 mt-md-0">
                                    <h1 className="display-4 fw-bold text-white">Iluminación</h1>
                                    <p className="lead text-white" style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Instalamos sistemas de iluminación que cambiarán la estética de su pileta.
                                        Con nuestra amplia gama de opciones podemos crear un ambiente mágico y cautivador
                                        que realzará la belleza de tu piscina durante las horas de la noche.
                                        <br />
                                        Ya sea que desees crear una atmósfera relajante y tranquila o una fiesta vibrante y llena de energía,
                                        nuestras luces LED te permitirán personalizar la experiencia visual de tu piscina según tu estado de ánimo y ocasión.
                                    </p>
                                </div>
                                <div className="col-md-5"></div>
                            </div>
                        </div>

                        {/* Versión Mobile */}
                        <div className="container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="text-dark fs-2 fw-bold mb-3">Iluminación</h1>
                                    <p className="text-dark fs-5">
                                        Instalamos sistemas de iluminación que cambiarán la estética de su pileta.
                                        Con nuestra amplia gama de opciones podemos crear un ambiente mágico y cautivador
                                        que realzará la belleza de tu piscina durante las horas de la noche.
                                        <br />
                                        Ya sea que desees crear una atmósfera relajante y tranquila o una fiesta vibrante y llena de energía,
                                        nuestras luces LED te permitirán personalizar la experiencia visual de tu piscina según tu estado de ánimo y ocasión.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Segunda imagen */}
                    <div className="carousel-item">
                        <div className="d-flex w-100 d-block col-12 col-md-5 position-relative" id="imgiluminacion2" ref={sectionRef}>
                            <div className="position-absolute w-100 h-100"></div>

                            <div className="row align-self-center w-100 d-none d-md-flex text-start" id="alineardescripcion">
                                <div className="col-12 col-md-7 mt-3 mt-md-0">
                                    <h1 className="display-4 fw-bold text-white">Iluminación</h1>
                                    <p className="lead text-white" style={{ textShadow: '0 0 5px rgba(0,0,0,0.5)' }}>
                                        Instalamos sistemas de iluminación que cambiarán la estética de su pileta.
                                        Con nuestra amplia gama de opciones podemos crear un ambiente mágico y cautivador
                                        que realzará la belleza de tu piscina durante las horas de la noche.
                                        <br />
                                        Ya sea que desees crear una atmósfera relajante y tranquila o una fiesta vibrante y llena de energía,
                                        nuestras luces LED te permitirán personalizar la experiencia visual de tu piscina según tu estado de ánimo y ocasión.
                                    </p>
                                </div>
                                <div className="col-md-5"></div>
                            </div>
                        </div>

                        {/* Versión Mobile */}
                        <div className="container d-block d-md-none mt-3 p-4 bg-light rounded shadow-sm">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="text-dark fs-2 fw-bold mb-3">Iluminación</h1>
                                    <p className="text-dark fs-5">
                                        Instalamos sistemas de iluminación que cambiarán la estética de su pileta.
                                        Con nuestra amplia gama de opciones podemos crear un ambiente mágico y cautivador
                                        que realzará la belleza de tu piscina durante las horas de la noche.
                                        <br />
                                        Ya sea que desees crear una atmósfera relajante y tranquila o una fiesta vibrante y llena de energía,
                                        nuestras luces LED te permitirán personalizar la experiencia visual de tu piscina según tu estado de ánimo y ocasión.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Botones del carrusel */}
                <button className="carousel-control-prev" type="button" data-bs-target="#carouseliluminacion" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouseliluminacion" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </>
    );
}

export default Iluminacion;
